import { isLocal } from '~/shared/utils/environments';

export const getEibHeaders = () => ({
  ...(isLocal() &&
    process.env.NEXT_PUBLIC_EIB_LOCAL_DEV_TOKEN && {
      authorization: `Bearer ${process.env.NEXT_PUBLIC_EIB_LOCAL_DEV_TOKEN}`
    }),
  'Content-Type': 'application/json'
});
